"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubClientType = exports.POSNotificationType = exports.KDSPrintAction = exports.ClientFilterType = exports.ClientType = exports.ClientThemeType = exports.ClientActionType = void 0;
var ClientActionType;
(function (ClientActionType) {
    ClientActionType[ClientActionType["PreviousOrders"] = 0] = "PreviousOrders";
    ClientActionType[ClientActionType["PaymentTerminalsModal"] = 1] = "PaymentTerminalsModal";
    ClientActionType[ClientActionType["PaymentTerminal"] = 2] = "PaymentTerminal";
    ClientActionType[ClientActionType["Ticket"] = 3] = "Ticket";
    ClientActionType[ClientActionType["Proforma"] = 4] = "Proforma";
    ClientActionType[ClientActionType["Cash"] = 5] = "Cash";
    ClientActionType[ClientActionType["OpenCashBox"] = 6] = "OpenCashBox";
    ClientActionType[ClientActionType["CustomPayment"] = 7] = "CustomPayment";
    ClientActionType[ClientActionType["CustomPaymentsModal"] = 8] = "CustomPaymentsModal";
    ClientActionType[ClientActionType["Invoice"] = 9] = "Invoice";
    ClientActionType[ClientActionType["Mews"] = 10] = "Mews";
    ClientActionType[ClientActionType["CollectionTicket"] = 11] = "CollectionTicket";
    ClientActionType[ClientActionType["GiftCards"] = 12] = "GiftCards";
    ClientActionType[ClientActionType["NextCourse"] = 13] = "NextCourse";
    ClientActionType[ClientActionType["CashInOut"] = 14] = "CashInOut";
    ClientActionType[ClientActionType["Retain24"] = 15] = "Retain24";
    ClientActionType[ClientActionType["MPSGiftCards"] = 16] = "MPSGiftCards";
    ClientActionType[ClientActionType["PrepaidWallets"] = 17] = "PrepaidWallets";
    ClientActionType[ClientActionType["Como"] = 18] = "Como";
    ClientActionType[ClientActionType["Stammy"] = 19] = "Stammy";
    ClientActionType[ClientActionType["Omniboost"] = 20] = "Omniboost";
    ClientActionType[ClientActionType["Maitres"] = 21] = "Maitres";
    ClientActionType[ClientActionType["ICoupons"] = 22] = "ICoupons";
    ClientActionType[ClientActionType["AirportLounge"] = 23] = "AirportLounge";
    ClientActionType[ClientActionType["PrePayment"] = 24] = "PrePayment";
})(ClientActionType = exports.ClientActionType || (exports.ClientActionType = {}));
var ClientThemeType;
(function (ClientThemeType) {
    ClientThemeType[ClientThemeType["Light"] = 0] = "Light";
    ClientThemeType[ClientThemeType["Dark"] = 1] = "Dark";
})(ClientThemeType = exports.ClientThemeType || (exports.ClientThemeType = {}));
var ClientType;
(function (ClientType) {
    ClientType[ClientType["Pos"] = 0] = "Pos";
    ClientType[ClientType["OrderManager"] = 1] = "OrderManager";
    ClientType[ClientType["Kds"] = 2] = "Kds";
    ClientType[ClientType["Waiter"] = 3] = "Waiter";
    ClientType[ClientType["Express"] = 4] = "Express";
    ClientType[ClientType["KdsMaster"] = 5] = "KdsMaster";
    ClientType[ClientType["KdsKitchen"] = 6] = "KdsKitchen";
    ClientType[ClientType["KdsGuest"] = 7] = "KdsGuest";
    ClientType[ClientType["VirtualPOS"] = 8] = "VirtualPOS";
})(ClientType = exports.ClientType || (exports.ClientType = {}));
var ClientFilterType;
(function (ClientFilterType) {
    ClientFilterType["Pos"] = "PosClient";
    ClientFilterType["OrderManager"] = "OrderManagerClient";
    ClientFilterType["Express"] = "ExpressClient";
    ClientFilterType["Kds"] = "KdsClient";
    ClientFilterType["KdsMasterClient"] = "KdsMasterClient";
    ClientFilterType["KdsGuestClient"] = "KdsGuestClient";
    ClientFilterType["KdsKitchenClient"] = "KdsKitchenClient";
})(ClientFilterType = exports.ClientFilterType || (exports.ClientFilterType = {}));
var KDSPrintAction;
(function (KDSPrintAction) {
    /** No printing */
    KDSPrintAction[KDSPrintAction["None"] = 0] = "None";
    /** Print when sub ticket arrives */
    KDSPrintAction[KDSPrintAction["Arrived"] = 1] = "Arrived";
    /** Print when sub ticket is accepted */
    KDSPrintAction[KDSPrintAction["Accepted"] = 2] = "Accepted";
    /** Print when sub ticket is marked as done */
    KDSPrintAction[KDSPrintAction["Done"] = 3] = "Done";
})(KDSPrintAction = exports.KDSPrintAction || (exports.KDSPrintAction = {}));
var POSNotificationType;
(function (POSNotificationType) {
    POSNotificationType[POSNotificationType["PayAndGoPayment"] = 0] = "PayAndGoPayment";
})(POSNotificationType = exports.POSNotificationType || (exports.POSNotificationType = {}));
var SubClientType;
(function (SubClientType) {
    SubClientType[SubClientType["None"] = 0] = "None";
    SubClientType[SubClientType["PayAndGo"] = 1] = "PayAndGo";
    SubClientType[SubClientType["PublicApi"] = 2] = "PublicApi";
})(SubClientType = exports.SubClientType || (exports.SubClientType = {}));
